import { useLocalStorage } from '@/hooks/useLocalStorage';

export type ViewMode = 'table' | 'cards';

/**
 * Generic hook for managing view mode (table/cards) with localStorage persistence
 *
 * @param storageKey - Unique key for localStorage (e.g., 'portfolio-view-mode')
 * @param defaultViewMode - Default view mode (default: 'table')
 * @returns View mode state and setter
 */
export const useViewMode = (
  storageKey: string,
  defaultViewMode: ViewMode = 'table',
) => {
  const [viewMode, setViewMode] = useLocalStorage<ViewMode>(
    storageKey,
    defaultViewMode,
  );

  return {
    viewMode,
    setViewMode,
  };
};
